module.exports = __webpack_public_path__ + "img/mike-berger-ceo-nachricht.d6e16ec2.jpg";